import { Map, List } from 'immutable'

import { actionTypes } from './actions'
import { util } from '../../util'
import { dataModels } from '../../dataModels'

const initialState = Map({
    product_details: Map({}),
    prePopulateProductImages: false,
    productImageLoading: false,
    products_loading: false,
    count: 0,
    pageNo: 1,
    size: 10,
    products_list: List([]),
    productAvailableImages: [],
    ingredientContains: [],
    product_error: '',
    contains: [],
    contains_loading: false,
    section_flags: [],
    tags_list: [],
    categories: Map({}),
    options_loading: '',
    show_completed_modal: false,
    marketplaces: {
        '7now': [],
        horizon: [],
    },
    serving_size_options: [],
    isProductNameUpdated: false,
    showEditConfirmation: null,
    equipments_list: List([]),
    product_patch_success: false,
    publish_alert: '',
    saved_section: '',
    products_filter: dataModels.getProductFilters(),
    manage_updates_filter: dataModels.getManageUpdatesFilters(),
    isProductProdPublished: false,
    isModifiedAreaAutoUpdated: null,
    add_products_catalog_switch: [
        { key: 'catalog_type', display_value: 'RIS', post_value: '7now' },
    ],
    manage_updates: {
        products: [],
        count: 0,
        pageNo: 1,
        size: 10,
        order: 'desc',
        orderBy: 'updated_at',
    },
    manage_products: {
        products: [],
        count: 0,
        pageNo: 1,
        size: 10,
        order: 'desc',
        orderBy: 'updated_at',
    },
    failed_products: null,
    manage_updates_alert: '',
})

export const productReducer = (state = initialState, action) => {
    const { type, payload, key } = action

    switch (type) {
        case actionTypes.FETCH_MANAGE_UPDATES_SUCCESS: {
            return state.merge({
                manage_updates: {
                    ...state.get('manage_updates'),
                    ...payload,
                },
                products_loading: false,
            })
        }

        case actionTypes.FETCH_PRODUCT_DETAILS_SUCCESS: {
            return state.merge({
                product_details: payload.productDetails,
                isModifiedAreaAutoUpdated: payload.isModifiedAreaAutoUpdated,
                products_loading: false,
                product_error: '',
                isProductProdPublished: util.isProductProdPublished(
                    payload.productDetails.visibility
                ),
            })
        }

        case actionTypes.UPDATE_PRODUCT_DETAILS_SUCCESS: {
            return state.set('product_details', payload)
        }

        case actionTypes.FETCH_IMPORTED_PRODUCTS_SUCCESS: {
            return state.merge({
                ...payload,
                products_loading: false,
            })
        }

        case actionTypes.SET_ADD_PRODUCTS_SWITCH: {
            return state.set('add_products_catalog_switch', payload)
        }

        case actionTypes.PRODUCT_LOADING_START: {
            return state.set('products_loading', true)
        }

        case actionTypes.PRODUCT_LOADING_END: {
            return state.set('products_loading', false)
        }

        case actionTypes.UPDATE_PRODUCT_ID_SLINS: {
            return state.set('id_slin', payload)
        }

        case actionTypes.ADD_NEW_PRODUCT_SUCCESS: {
            return state.merge(state, {
                product_details: payload,
                products_loading: false,
                prePopulateProductImages: true,
                product_error: '',
            })
        }

        case actionTypes.PRE_POPULATE_PRODUCT_IMAGES: {
            return state.merge(state, {
                prePopulateProductImages: payload,
                productImageLoading: true,
                products_loading: false,
                product_error: '',
            })
        }

        case actionTypes.SET_PRODUCT_AVAILABLE_IMAGES: {
            return state.merge(state, {
                productAvailableImages: payload,
                productImageLoading: false,
                prePopulateProductImages: false,
                product_error: '',
            })
        }

        case actionTypes.CLEAR_PRODUCT_AVAILABLE_IMAGES: {
            return state.merge({
                productAvailableImages: [],
                product_details: Map({}),
            })
        }

        case actionTypes.STOP_PRODUCT_IMAGE_LOADING: {
            return state.set('productImageLoading', false)
        }

        case actionTypes.START_PRODUCT_IMAGE_LOADING: {
            return state.set('productImageLoading', true)
        }

        case actionTypes.PATCH_PRODUCT_DETAILS_SUCCESS: {
            return state.merge({
                saved_section:
                    key /* saved_section key is used to forcefully close the appropriate accordion section*/,
                product_details: payload.productDetails,
                products_loading: false,
                product_error: '',
                show_completed_modal: payload.show_completed_modal,
                product_patch_success: true,
                showEditConfirmation: null,
                isProductProdPublished: util.isProductProdPublished(payload.visibility),
                isModifiedAreaAutoUpdated: false,
            })
        }

        case actionTypes.CLEAR_COMPLETED_MODAL: {
            return state.set('show_completed_modal', false)
        }

        case actionTypes.SET_PRODUCT_ERROR: {
            return state.set('product_error', payload)
        }

        case actionTypes.SET_NUTRITION_CONTAINS: {
            return state.set('contains', payload)
        }

        case actionTypes.CONTAINS_LOADING_START: {
            return state.set('contains_loading', true)
        }

        case actionTypes.CONTAINS_LOADING_END: {
            return state.set('contains_loading', false)
        }

        case actionTypes.SET_SECTION_FLAG: {
            return state.set('section_flags', payload)
        }

        case actionTypes.FETCH_TAGS_SUCCESS: {
            return state.set('tags_list', payload)
        }

        case actionTypes.OPTIONS_LOADING_START: {
            return state.set('options_loading', payload)
        }

        case actionTypes.OPTIONS_LOADING_END: {
            return state.set('options_loading', '')
        }

        case actionTypes.FETCH_MARKETPLACES_SUCCESS: {
            let currMarkets = state.get('marketplaces')
            currMarkets = { ...currMarkets, ...payload }
            return state.set('marketplaces', currMarkets)
        }

        case actionTypes.FETCH_SERVING_SIZE_UOM_SUCCESS: {
            return state.set('serving_size_options', payload)
        }

        case actionTypes.FETCH_EQUIPMENTS_SUCCESS: {
            return state.set('equipments_list', payload)
        }

        case actionTypes.TOGGLE_PRODUCT_PATCH_SUCCESS: {
            return state.set('product_patch_success', !state.get('product_patch_success'))
        }

        case actionTypes.UPDATE_PRODUCT_NAME_SUCCESS: {
            return state.merge({
                product_details: {
                    ...state.get('product_details'),
                    ...payload,
                },
                products_loading: false,
                isProductNameUpdated: true,
                isModifiedAreaAutoUpdated: false,
            })
        }

        case actionTypes.SET_EDIT_CONFIRMATION: {
            return state.set('showEditConfirmation', payload)
        }

        case actionTypes.CLEAR_EDIT_CONFIRMATION: {
            return state.set('showEditConfirmation', null)
        }

        case actionTypes.TOGGLE_PRODUCT_NAME_SUCCESS: {
            return state.set('isProductNameUpdated', !state.get('isProductNameUpdated'))
        }

        case actionTypes.PUBLISH_PRODUCT_SUCCESS: {
            const publish_alert = util.publishAlertStr(payload.visibility)
            return state.merge({
                products_loading: false,
                product_details: payload,
                publish_alert,
                isProductProdPublished: util.isProductProdPublished(payload.visibility),
            })
        }

        case actionTypes.CLEAR_PUBLISH_ALERT: {
            return state.set('publish_alert', '')
        }

        case actionTypes.CLEAR_SAVED_SECTION: {
            return state.set('saved_section', '')
        }

        case actionTypes.UPDATE_MANAGE_UPDATE_FILTERS: {
            return state.set('manage_updates_filter', payload)
        }

        case actionTypes.UPDATE_PRODUCTS_FILTERS: {
            return state.set('products_filter', payload)
        }

        case actionTypes.CLEAR_MANAGE_UPDATES_FILTERS: {
            return state.set('manage_updates_filter', dataModels.getManageUpdatesFilters())
        }

        case actionTypes.CLEAR_PRODUCTS_FILTERS: {
            return state.merge({
                products_filter: dataModels.getProductFilters(),
            })
        }

        case actionTypes.BULK_PUBLISH_PRODUCTS_SUCCESS: {
            return state.merge({
                manage_updates: {
                    ...state.get('manage_updates'),
                    products: payload.products,
                },
                products_loading: false,
                manage_updates_alert: payload.manage_updates_alert,
                failed_products: payload.failed_products,
            })
        }

        case actionTypes.RESET_FAILED_PRODUCTS: {
            return state.merge({
                failed_products: null,
            })
        }

        case actionTypes.FETCH_MANAGE_PRODUCTS_SUCCESS: {
            return state.merge({
                manage_products: {
                    ...state.get('manage_products'),
                    ...payload,
                },
                products_loading: false,
            })
        }

        case actionTypes.BULK_UPDATE_CATALOG_PRODUCTS_SUCCESS: {
            return state.merge({
                ...payload,
            })
        }

        case actionTypes.SET_MANAGE_UPDATES_ALERT: {
            return state.merge({
                manage_updates_alert: payload,
                products_loading: false,
            })
        }
        case actionTypes.CLEAR_MANAGE_UPDATES_ALERT: {
            return state.merge({
                manage_updates_alert: '',
            })
        }

        case actionTypes.TOGGLE_MODIFIED_AREA_AUTO_UPDATE: {
            return state.set('isModifiedAreaAutoUpdated', payload)
        }

        case actionTypes.UNMOUNT_PRODUCT: {
            return state.merge({
                isProductProdPublished: false,
                isModifiedAreaAutoUpdated: false,
            })
        }

        default: {
            return state
        }
    }
}
